import { lazy } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import PrivateRoute from 'router/PrivateRoute/PrivateRoute';

import Auth from 'Auth/AuthContainer';
import Storage from 'Storage/StorageContainer';
import Settings from 'Settings/SettingsContainer';
import Groups from 'Groups/GroupsContainer';
import Public from 'Public/PublicContainer';
import Shared from 'Shared/SharedContainer';
import SearchContainer from 'Search/SearchContainer';
import Extensions from 'Extensions/ExtensionsContainer';
import File from 'File/FileContainer';
import { useNavigate } from 'react-router-dom';
import { useLayoutEffect } from 'react';
import { setNavigate } from 'router/navigation';

import { Error404, Error403, ProductGate } from '_common/components';

/**
 * Lazy loaded components
 * This is done to reduce the main bundle size
 * The components are loaded only when they are needed
 */
const Editor = lazy(() => import('Editor/Editor'));
const PDF = lazy(() => import('PDF/PDF'));
const Presentation = lazy(() => import('Presentation/Presentation'));

/**
 * ROUTER
 * doDOC's route configuration
 */
const AppRouter = () => {
  const navigate = useNavigate();

  useLayoutEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Navigate to="/storage" />
          </PrivateRoute>
        }
      />
      <Route
        path="/editor/:id"
        element={
          <PrivateRoute>
            <Editor />
          </PrivateRoute>
        }
      />
      <Route
        path="/storage/*"
        element={
          <PrivateRoute>
            <Storage />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/*"
        element={
          <PrivateRoute>
            <Settings />
          </PrivateRoute>
        }
      />
      <Route
        path="/groups/*"
        element={
          <PrivateRoute>
            <Groups />
          </PrivateRoute>
        }
      />
      <Route
        path="/shared/*"
        element={
          <PrivateRoute>
            <Shared />
          </PrivateRoute>
        }
      />
      <Route
        path="/search/*"
        element={
          <PrivateRoute>
            <SearchContainer />
          </PrivateRoute>
        }
      />
      <Route path="/auth/*" element={<Auth />} />
      <Route path="/public/*" element={<Public />} />
      <Route
        path="/extensions/*"
        element={
          <PrivateRoute>
            <Extensions />
          </PrivateRoute>
        }
      />
      <Route
        path="/file/*"
        element={
          <PrivateRoute>
            <File />
          </PrivateRoute>
        }
      />
      <Route
        path="/pdf/:id"
        element={
          <PrivateRoute>
            <ProductGate product="product.pdf_reviewer">
              <PDF />
            </ProductGate>
          </PrivateRoute>
        }
      />
      <Route
        path="/presentation/:id"
        element={
          <PrivateRoute>
            <ProductGate product="product.presentation_reviewer">
              <Presentation />
            </ProductGate>
          </PrivateRoute>
        }
      />
      <Route
        path="/404"
        element={
          <PrivateRoute>
            <Error404 />
          </PrivateRoute>
        }
      />
      <Route
        path="/403"
        element={
          <PrivateRoute>
            <Error403 />
          </PrivateRoute>
        }
      />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
};

export default AppRouter;
